export default {
    cities: state => {
        return state.cities;
    },
    countries: state => {
        return state.countries;
    },
    provinces: state => {
        return state.provinces;
    },
    issuedCountries: state => {
        return state.issuedCountries;
    },
    issuedProvinces: state => {
        return state.issuedProvinces;
    },
    issuedCities: state => {
        return state.issuedCities;
    },
    birthCities: state => {
        return state.birthCities;
    },
}
